import React from 'react';
import PropTypes from 'prop-types';
import { compose, setDisplayName, setPropTypes } from 'recompose';
import classNames from 'classnames';
import { v4 as uuid } from 'uuid';
import styles from './Checklist.scss';

export const Checklist = ({ features, size }) => (
  <ul
    className={classNames(
            styles.root,
            styles[size],
        )}
    >
    {
            features.map(feature => (
              <li key={uuid()} className={styles.item}>
                <span className={styles.icon} />
                <span className={styles.text} dangerouslySetInnerHTML={{ __html: feature }} />
              </li>
            ))
        }
  </ul>
);

export default compose(
  setDisplayName('Checklist'),
  setPropTypes({
    features: PropTypes.arrayOf(PropTypes.string).isRequired,
    size: PropTypes.string.isRequired,
  }),
)(Checklist);
